import React from 'react';
import { Stars, SampleNote } from './QuickTestimonials';
type Testimonial = {
  initials: string;
  quote: string;
  name: string;
  location: string;
};
const TESTIMONIALS: Testimonial[] = [{
  initials: 'RM',
  quote: 'I used to spend most of Sunday preparing and adapting materials for the following week. Now I choose what I need, adjust it, and I’m ready.',
  name: 'Rachel M.',
  location: 'Manchester, UK'
}, {
  initials: 'EB',
  quote: 'The activity library gives me much more structure. I can adapt the same resource instead of creating completely different materials every time.',
  name: 'Emily B.',
  location: 'Melbourne, Australia'
}, {
  initials: 'SC',
  quote: 'The visual support materials are what made the biggest difference. I can quickly prepare routines and supports for different classroom situations.',
  name: 'Sophie C.',
  location: 'Auckland, New Zealand'
}, {
  initials: 'JH',
  quote: 'I work with students who need very different levels of support. Having adaptations and practical tools ready makes planning much easier.',
  name: 'Jessica H.',
  location: 'Toronto, Canada'
}, {
  initials: 'CW',
  quote: 'I had years of activities, printables, and visual resources scattered across different folders. Now everything I actually use is organized in one system.',
  name: 'Claire W.',
  location: 'Birmingham, UK'
}, {
  initials: 'OS',
  quote: 'The Differentiation Toolkit is incredibly practical. It saves preparation time without forcing me to use the exact same approach with every student.',
  name: 'Olivia S.',
  location: 'Sydney, Australia'
}, {
  initials: 'HB',
  quote: 'I am 41 and I have taught in a special education classroom for twelve years, so I genuinely did not expect a resource pack to change my week. What changed it was the differentiation toolkit: I now take one activity and produce a high-support version, a moderate-support version, and an independent version in about ten minutes. My teaching assistants finally know exactly what to run with each group, and I stopped photocopying at seven in the morning.',
  name: 'Helen B.',
  location: 'Leeds, United Kingdom'
}, {
  initials: 'MK',
  quote: 'My caseload is nine students across three classrooms, and transitions were where everything used to fall apart. I printed the visual routines and first–then boards in one afternoon and laminated them the same day. Three weeks later, two of my students are moving between activities without an adult prompt, and my behaviour incident notes have dropped noticeably. That alone was worth the price.',
  name: 'Megan K.',
  location: 'Christchurch, New Zealand'
}, {
  initials: 'AD',
  quote: 'At 34 I moved from mainstream teaching into a specialist support role and I was completely overwhelmed by preparation. The planning and progress toolkit gave me a structure I could actually keep up with: observation sheets, skill trackers, and adaptation notes that take minutes instead of evenings. When I sat down with parents at review meetings, I had real evidence in front of me for the first time.',
  name: 'Amelia D.',
  location: 'Perth, Australia'
}, {
  initials: 'PN',
  quote: 'Two of my students are non-speaking and communication was the part of my day I worried about most. The communication support pack gave me request cards, choice boards, and self-advocacy supports that I could put into use immediately, without designing anything myself. One of them now asks for a break independently, and that single change transformed the afternoons in my classroom.',
  name: 'Priya N.',
  location: 'Calgary, Canada'
}, {
  initials: 'CF',
  quote: 'I am 52 and I lead a learning support department, so I am the person everyone asks when a substitute arrives or a plan collapses at short notice. The substitute and emergency lesson pack is now printed and sitting in a folder by the door, and the low-prep games get used every single week. My whole team uses the same system, which means the students get consistency even on the days that go sideways.',
  name: 'Caroline F.',
  location: 'Edinburgh, United Kingdom'
}];
export function Testimonials() {
  return <section aria-labelledby="testimonials-title" className="w-full bg-cream px-3 py-7 sm:px-5" data-id="element-223" data-mp="1gz4wd3e9z8fd">
      <div className="mx-auto max-w-6xl" data-id="element-224" data-mp="1vnhxsfw4tjh9">
        <div className="text-center" data-id="element-225" data-mp="1vojb6r0mei25">
          <span className="font-head text-[10px] uppercase tracking-[0.14em] text-steel sm:text-xs" data-id="element-226" data-mp="1qvq0znmduhio">
            Trusted by special education teachers
          </span>
          <h2 id="testimonials-title" className="mt-1 font-head text-2xl uppercase leading-none text-ink sm:text-4xl" data-id="element-227" data-mp="1zobjr3q0ko7i">
            What teachers are saying
          </h2>
          <p className="mt-1 flex items-center justify-center gap-1.5 text-[13px] font-bold text-ink" data-id="element-228" data-mp="2eksrzm2wpmpu">
            <Stars data-id="element-229" data-mp="29kekq694qgsv" />
            4.9/5 · 564+ Special Education Teachers
          </p>
          <SampleNote className="mt-1" data-id="element-230" data-mp="k7t99k38ccec" />
        </div>

        <div className="mt-4 grid gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-231" data-mp="f8zrvgkto18w">
          {TESTIMONIALS.map(item => <figure key={item.name} className="flex flex-col rounded-xl border border-ink/10 bg-white p-3" data-id="element-232" data-mp="2qva4jtm5gajm">
              <div className="flex items-center gap-2" data-id="element-233" data-mp="2vv67rqn0vxy4">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-petrol text-[11px] font-bold text-white" data-id="element-234" data-mp="2vwpmhct160xs">
                  {item.initials}
                </span>
                <Stars data-id="element-235" data-mp="2m30f0eoy5chv" />
              </div>
              <blockquote className="mt-1.5 text-[13px] leading-snug text-body" data-id="element-236" data-mp="284slyhv16vbz">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-2 text-[11px] font-bold uppercase tracking-wide text-ink" data-id="element-237" data-mp="2c8gtj0jnxqx8">
                {item.name}
                <span className="ml-1 font-medium normal-case tracking-normal text-muted" data-id="element-238" data-mp="2367pmtiwgvst">
                  {item.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}